const toNameCase = (value) => {
  if (value === null || value === undefined) return value;

  const s = String(value).trim();
  if (!s) return s;

  return s
    .split(/(\s+)/)
    .map((token) => {
      if (/^\s+$/.test(token)) return token;

      return token
        .split(/(-+)/)
        .map((part) => {
          if (/^-+$/.test(part)) return part;
          const p = part.trim();
          if (!p) return part;
          const lower = p.toLocaleLowerCase('ru-RU');
          return lower[0].toLocaleUpperCase('ru-RU') + lower.slice(1);
        })
        .join('');
    })
    .join('');
};

export default toNameCase;
